import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Col, LoadingTip, Row } from 'tea-component';
import { FilterFixed, useFilterDataHook } from '@op/components/FilterCommon';
import { useHistory } from 'umi';
import CardLoading from '@op/components/CardLoading';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import useStorageOperation from '@/pages/opinion/hooks/useStorageOperation';
import moment from 'moment';
import { gptReport } from '@/pages/opinion/services';
import { notificationError } from './constant';
import axios from 'axios';
import { debounce } from 'throttle-debounce';
import canvasSize from 'canvas-size';
import html2pdf from 'html2pdf.js';
import * as FileSaver from 'file-saver';
import './styles/markdown-preview.scss';
import './styles/index.scss';
import {
  handleContentScroll,
  handleNavigatorScroll,
} from '@/pages/opinion/utils';
import EmailModal from './components/email-modal';
import TipsModal from './components/tips-modal';
import Download from '@/pages/opinion/components/FilterBoxCommon/filters/download';
import CardSlot from '@/pages/opinion/components/CardSlot';
import {
  useInitBuriedPointInfo,
  buriedPagePoint,
} from '@/pages/opinion/operationLog/buriedPoint';
import GPTPointFunc from '@op/operationLog/pages/gpt';
import { objToUrl } from '@/pages/opinion/utils/url';
import { getBasePath } from '@/utils/utils';
import {
  getGPTDateType,
  getGptStoreKey,
} from '@/pages/opinion/utils/storageUtils';
import { mdContentToHtml } from '@op/utils/text';
import DOMPurify from 'dompurify';

const debounceTime = 100;
export default function Gpt({
  gameInfo,
  wholeGameInfo,
  kind,
  handleKindOnchange,
  contentRef,
  scrolling,
  custom = true,
  specialReportList,
  needAddPoint = true,
}: any) {
  // console.log('custom', custom);

  const history = useHistory();
  useInitBuriedPointInfo({
    buriedPoint: GPTPointFunc(location.pathname),
    triggerPagePoint: false,
  });

  const isFirstTime = useRef(true);
  const { edition_unified_id, entity_type, id_type } = gameInfo;

  function setUrlInfo(obj: any = {}) {
    const { pathname, query } = history.location;
    const urlParams = objToUrl({
      ...query,
      gameid: query.gameid || edition_unified_id,
      ...obj,
    });
    const url = `${getBasePath() + pathname}?${urlParams}`;
    window.history.replaceState(null, '', url);
  }

  const { changeFilter, filter, filterOptions } = useFilterDataHook({
    pageName: 'Report_GPT',
  });
  const [loading, setLoading] = useState(true);
  const { formatMessage } = useLanguage();

  const [reportGptConfig, setReportGptConfig] = useState<{
    type: number[];
    language: {
      [key: string]: string[][];
    };
  }>({
    type: [],
    language: {},
  });

  useEffect(() => {
    if (scrolling) {
      setNavigator(
        handleContentScroll(
          defaultNavigator,
          headings.map((item) => item.slug),
          contentRef,
          10,
        ),
      );
    }
  }, [scrolling]);

  const [reportGptType, setReportGptType] = useState<string[]>([]);

  const typeArray: [string, string][] = [
    ['1', 'Day'],
    ['2', 'Week'],
    ['3', 'Month'],
  ];

  const { data: curOpinionFilter, setStore } = useStorageOperation({
    storage: sessionStorage,
    model: 'merge',
    defaultValue: {},
    storageKey: getGptStoreKey(kind, edition_unified_id),
  });
  const {
    start_time: urlStartTime,
    end_time: urlEndTime,
    dateTab: urlDateTab,
    language: urlLanguage,
  } = history?.location?.query;

  const isProd = true;
  const typeMap: any = {
    Day: '1',
    Week: '2',
    Month: '3',
  };

  const [hasDataStartTime, setHasDataStartTime] = useState('');
  const [hasDataEndTime, setHasDataEndTime] = useState('');
  const [empty, setEmpty] = useState(isProd);
  const [languageSelect, setLanguageSelect] = useState(
    curOpinionFilter?.lang || '',
  );
  const hasStorageTime =
    curOpinionFilter?.list?.currentTime?.length === 2 ||
    (urlStartTime && urlEndTime);

  const [time, setTime] = useState<[string, string]>(
    hasStorageTime
      ? [
        curOpinionFilter?.list?.currentTime[0],
        curOpinionFilter?.list?.currentTime[1],
      ]
      : [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
  );

  const [dateTab, setDateTab] = useState(curOpinionFilter?.list?.dateTab || '');
  const [renderText, setRenderText] = useState('');
  const [defaultNavigator, setDefaultNavigator] = useState('');
  const [navigator, setNavigator] = useState('');
  const [headings, setHeadings] = useState<
    {
      level: number;
      text: string;
      slug: string;
    }[]
  >([]);
  const [params, setParams] = useState<any>({});
  const [mdFileUrl, setMdFileUrl] = useState('');

  const [visible, setVisible] = useState(false);
  const [tipsVisible, setTipsVisible] = useState(false);

  const markdownRef = useRef<HTMLDivElement | null>(null);
  const [rendering, setRendering] = useState(false);

  const getRefreshNewTimeElement = (text: string) => (
    <Button
      type="link"
      style={{ paddingLeft: 5 }}
      onClick={() => {
        const { language: lang, date_type } = filter;
        const type = getGPTDateType(date_type);
        handleGotoHasMarkdown(hasDataStartTime, hasDataEndTime, type, lang);
      }}
    >
      {text}
    </Button>
  );

  const handleGotoHasMarkdown = (
    curHasDataStartTime = hasDataStartTime,
    curHasDataEndTime = hasDataEndTime,
    curDateTab = dateTab,
    curLanguage = languageSelect,
  ) => {
    // 跳转到最新有的
    console.log(
      '跳转到最新有数据的',
      curHasDataStartTime,
      curHasDataEndTime,
      curDateTab,
      curLanguage,
    );

    const value: [string, string] = [
      curHasDataStartTime,
      curHasDataEndTime,
    ];
    console.log(curLanguage, 'request');
    setUrlInfo({
      start_time: curHasDataStartTime,
      end_time: curHasDataEndTime,
      language: curLanguage,
      kind,
      dateTab: curDateTab,
    });

    setStore({
      list: { currentTime: value, dateTab: curDateTab },
      lang: curLanguage,
    });
    setTime(value);
    setLanguageSelect(curLanguage);
    setDateTab(curDateTab);
    getReportData(value, curDateTab, curLanguage);
    isFirstTime.current = false;
  };

  const getReportData = async (
    value?: string[],
    tabType?: string,
    language?: string,
  ) => {
    const curTime = value ?? time;
    const curDateTab = tabType ?? dateTab;
    const curLanguage = language ?? languageSelect;
    if (needAddPoint) {
      buriedPagePoint();
    }

    try {
      setLoading(true);
      setHasDataStartTime('');
      setHasDataEndTime('');
      setRenderText('');
      setDefaultNavigator('');
      setNavigator('');
      setHeadings([]);
      setEmpty(true);

      let type = Number(typeMap[curDateTab]);
      // TODO: 重点：时间不相同，并且type=1，就会将type 变为 4
      if (
        type === 1 &&
        moment(curTime[0]).format('YYYY-MM-DD') !==
        moment(curTime[1]).format('YYYY-MM-DD')
      ) {
        type = 4;
      }

      const curParmas = {
        edition_unified_id,
        id_type,
        entity_type,
        start_time: `${curTime[0]}`,
        end_time: `${curTime[1]}`,
        type,

        language: curLanguage,

        kind: Number(kind),
      };

      setParams(curParmas);
      if (!curLanguage)
        return handleEmptyMarkdown(
          undefined,
          undefined,
          curDateTab,
          curLanguage,
          curParmas,
        );

      const res = await gptReport({ ...curParmas });

      if (res) {
        const { list, has_data_end_time, has_data_start_time } = res;
        if (has_data_start_time) setHasDataStartTime(has_data_start_time);
        if (has_data_end_time) setHasDataEndTime(has_data_end_time);

        if (list && Array.isArray(list) && list.length > 0) {
          const [{ md_file: mdFile }] = list;

          getMdFile(mdFile);
        } else {
          handleEmptyMarkdown(
            has_data_start_time,
            has_data_end_time,
            curDateTab,
            curLanguage,
            curParmas,
          );
        }
      } else {
        handleEmptyMarkdown();
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      handleEmptyMarkdown();
    }
  };
  const requestNum = useRef(0);
  const handleEmptyMarkdown = (
    curHasDataStartTime = hasDataStartTime,
    curHasDataEndTime = hasDataEndTime,
    curDateTab = dateTab,
    curLanguage = languageSelect,
    curParmas = params,
  ) => {
    console.log(
      '空白 markdown 情况处理',
      hasStorageTime,
      curHasDataStartTime,
      curHasDataEndTime,
      curDateTab,
      curLanguage,
    );

    // 如果本地没有存储日期的话，代表第一次进来，直接跳转到有的日期,如果发现三次都没有数据，就直接取消跳转
    if (
      isFirstTime.current === true &&
      curHasDataStartTime &&
      curHasDataEndTime &&
      curDateTab &&
      curLanguage &&
      requestNum.current < 3
    ) {
      requestNum.current = requestNum.current + 1;
      return handleGotoHasMarkdown(
        curHasDataStartTime,
        curHasDataEndTime,
        curDateTab,
        curLanguage,
      );
    }

    setLoading(false);
    setEmpty(true);

    // 0630 新增弹窗

    if (!custom) return; // 不是传统GPT，直接返回

    if (!curLanguage && kind) {
      return notificationError(
        'Operation failed. Error: Language not configured.',
      );
    }

    let hasToday = false;

    if (curParmas?.start_time && curParmas?.end_time) {
      hasToday = moment().isBetween(
        moment(curParmas.start_time),
        moment(curParmas.end_time),
        'day',
        '[]',
      );
    }

    if (hasToday) {
      setTipsVisible(true);
      setVisible(false);
    } else {
      setVisible(true);
      setTipsVisible(false);
    }
  };

  const getMdFile = (url: string) => {
    if (url) {
      setEmpty(false);
      setMdFileUrl(url);
      axios
        .get(url)
        .then((res) => {
          if (res?.data) {
            const text = res.data;
            renderContent(text);
          } else {
            handleEmptyMarkdown();
          }
        })
        .catch((error) => {
          console.log(error);
          handleEmptyMarkdown();
        });
    } else {
      handleEmptyMarkdown();
    }
  };

  const renderContent = (text: string) => {
    const { html, headings, navigator } = mdContentToHtml(text);
    setRenderText(html);
    setHeadings(headings);
    setDefaultNavigator(navigator);
    setNavigator(navigator);
    setLoading(false);
  };

  const download = () => {
    const gameName = wholeGameInfo?.entity_name || '';
    const fileName = `Opinions_${gameName}_GPT_Auto_Reports_${moment(
      time[0],
    ).format('YYYYMMDD')}`;

    let isValidCanvas = true;

    // console.log(document.querySelectorAll('details'));

    // document.querySelectorAll('details').forEach(detail => {
    //   console.log('detail', detail);
    //   detail.open = true;
    // });

    const clone = markdownRef.current?.cloneNode(true);

    clone?.querySelectorAll?.('details')?.forEach((detail) => {
      if (!detail.hasAttribute('open')) {
        const summaryElement = detail.querySelector('summary');
        if (summaryElement) {
          // 如果存在 summary，则使用其内容
          detail.innerHTML = `<summary>${summaryElement.innerHTML}</summary>`;
        } else {
          // 如果不存在 summary，则创建一个空的 summary
          detail.innerHTML = `<summary></summary>`;
        }
      }
    });

    const worker = html2pdf()
      .set({
        pagebreak: { mode: ['avoid-all', 'css'] },
        thenExternal: () => {
          console.log(isValidCanvas);
        },
        html2canvas: {
          scale: 2,
          useCORS: true,
          async onrendered(canvas: { width: any; height: any }) {
            isValidCanvas = canvasSize.test({
              width: canvas.width,
              height: canvas.height,
            });

            if (isValidCanvas) {
              worker
                .toImg()
                .toPdf()
                .save(`${fileName}.pdf`)
                .then(() => {
                  setRendering(false);
                });
            } else {
              axios
                .get(mdFileUrl, { responseType: 'blob' })
                .then((res) => {
                  if (res?.data) {
                    FileSaver.saveAs(res.data, `${fileName}.md`);
                  }
                  setRendering(false);
                })
                .catch(() => setRendering(false))
                .finally(() => setRendering(false));
            }
          },
        },
        // [top,left,bottom,right]
        margin: [0, 10, 0, 10],
        image: {
          type: 'jpeg',
          quality: 1,
        },
      })
      .from(clone)
      .toCanvas();
  };

  useEffect(() => {
    // if (!isProd) {
    //   renderContent(markdownFile);
    //   return;
    // }
    if (specialReportList) {
      const curReport = specialReportList.find(
        (item: any) => item.activeId === kind,
      );
      if (curReport) {
        getMdFile(curReport.url);
      } else {
        setEmpty(true);
        setLoading(false);
      }

      buriedPagePoint();
      setUrlInfo({
        kind,
      });
      return;
    }
  }, [gameInfo]);

  const handleNewMdFile = (url: any) => {
    getMdFile(url);
  };

  useEffect(() => {
    if (reportGptType && reportGptType.length > 0) {
      const options: { tabName: string }[] = [];
      typeArray.map((item) => {
        if (reportGptType.includes(item[0])) {
          options.push({ tabName: item[1] });
        }
      });

      let {
        currentTime: time,
        dateTab,
        lang: language,
      } = curOpinionFilter?.list || {};

      // 以 url 为主
      if (urlStartTime && urlEndTime) {
        time = [urlStartTime, urlEndTime];
      }
      if (urlDateTab) {
        dateTab = urlDateTab;
      }
      if (urlLanguage) {
        language = urlLanguage;
      }

      if (!time && !dateTab) {
        dateTab = options[0].tabName;
        if (dateTab === 'Week') {
          time = [
            moment().subtract('7', 'days').format('YYYY-MM-DD'),
            moment().subtract(1, 'days').format('YYYY-MM-DD'),
          ];
        } else if (dateTab === 'Month') {
          time = [
            moment().subtract('30', 'days').format('YYYY-MM-DD'),
            moment().subtract(1, 'days').format('YYYY-MM-DD'),
          ];
        } else {
          time = [
            moment().subtract(1, 'days').format('YYYY-MM-DD'),
            moment().subtract(1, 'days').format('YYYY-MM-DD'),
          ];
        }
      } else if (!time && dateTab) {
        if (dateTab === 'Week') {
          time = [
            moment().subtract('7', 'days').format('YYYY-MM-DD'),
            moment().subtract(1, 'days').format('YYYY-MM-DD'),
          ];
        } else if (dateTab === 'Month') {
          time = [
            moment().subtract('30', 'days').format('YYYY-MM-DD'),
            moment().subtract(1, 'days').format('YYYY-MM-DD'),
          ];
        } else {
          time = [
            moment().subtract(1, 'days').format('YYYY-MM-DD'),
            moment().subtract(1, 'days').format('YYYY-MM-DD'),
          ];
        }
      } else if (time && !dateTab) {
        const [startTime, endTime] = time;
        if (startTime === endTime && options.includes[1]) {
          dateTab = 'Day';
        } else if (
          moment(startTime).add(6, 'days').format('YYYY-MM-DD') === endTime &&
          options.includes[2]
        ) {
          dateTab = 'Week';
        } else if (
          moment(startTime).add(29, 'days').format('YYYY-MM-DD') === endTime &&
          options.includes[3]
        ) {
          dateTab = 'Month';
        } else {
          dateTab = options[0].tabName;
        }
      }
      setLanguageSelect(language);
      setDateTab(dateTab);
      setTime(time);
    }
  }, [reportGptType]);

  const userSynchronousValue = useMemo(
    () => ({
      start_time: time[0],
      end_time: time[1],
      kind,
      language: languageSelect,
      type: dateTab,
    }),
    [time, kind, languageSelect, dateTab],
  );
  return (
    <>
      <TipsModal
        value={tipsVisible}
        setValue={setTipsVisible}
        tips={{
          en: (
            <>
              In order to obtain a full data report for the day, the Opinions
              system generates a GPT report using T-1's rules.
              <br />
              The date you selected includes today ({moment().format('MMDD')}
              ), it is recommended to change the end date to yesterday (
              {moment().subtract(1, 'days').format('MMDD')}), or please come
              tomorrow to apply for the {moment().format('MMDD')} report.
            </>
          ),
          zh: (
            <>
              为了获得当天的完整数据报告，舆情系统使用 T-1 的规则生成GPT报告。
              <br />
              您选择的日期包含今天（{moment().format('MMDD')}
              ），建议结束日期切换为昨天（
              {moment().subtract(1, 'days').format('MMDD')}），或请明日来申请
              {moment().format('MMDD')}报告。
            </>
          ),
        }}
      ></TipsModal>
      <EmailModal
        value={visible}
        setValue={setVisible}
        params={params}
        handleNewMdFile={handleNewMdFile}
      ></EmailModal>
      <>
        <FilterFixed
          beforeCacheDealwithData={() => false}
          userSynchronousValue={userSynchronousValue}
          filter={filterOptions}
          isTile
          operateShowOptions={null}
          confirm={(value: any) => {
            if (!custom) return;

            changeFilter({ ...value });

            const { language: lang, date_type, start_time, end_time } = value;
            const type = getGPTDateType(date_type);

            const curTime: [string, string] = [
              moment(start_time).format('YYYY-MM-DD'),
              moment(end_time).format('YYYY-MM-DD'),
            ];

            const obj = {
              start_time: curTime[0],
              end_time: curTime[1],
              language: lang,
              kind,
              dateTab: type,
            };
            setUrlInfo(obj);
            // setTime(curTime);
            // setDateTab(type);
            // setLanguageSelect(lang);
            setStore({
              lang,
              list: {
                currentTime: curTime,
                dateTab: type,
              },
            });

            getReportData(curTime, type, lang);
          }}
          backCondOriginData={(gptFilter) => {
            const defaultType = '1';
            const defaultLanguage = ['en', 'English', '英语'];
            if (gptFilter?.report_gpt_config) {
              const baseConfig = gptFilter?.report_gpt_config || {};
              let type = baseConfig.type[kind];
              let language = baseConfig.language[kind];
              console.log("---------")
              handleKindOnchange?.(baseConfig.kind);

              if (!(Array.isArray(type) && type.length > 0)) {
                type = [defaultType];
              } else {
                if (!type.includes(defaultType)) {
                  type.push(defaultType);
                  language[defaultType] = [defaultLanguage];
                }
              }

              if (!language) {
                language = { [defaultType]: [defaultLanguage] };
              }

              setReportGptConfig({
                type,
                language,
              });

              if (Array.isArray(type) && type.length === 0) {
                setReportGptType([defaultType]);
              } else {
                setReportGptType(type);
              }
            } else {
              setReportGptType([defaultType]);
            }
          }}
        ></FilterFixed>

        <CardLoading loading={loading}>
          {!loading ? (
            <CardSlot>
              <Row>
                <Col span={24}>
                  {empty ? (
                    <div className="dbo-markdown-preview-empty">
                      {formatMessage({
                        id: 'No data under current selections.',
                      })}

                      {hasDataStartTime && hasDataEndTime
                        ? getRefreshNewTimeElement(
                          formatMessage({
                            id: 'Click to view recent report',
                          }),
                        )
                        : ''}
                    </div>
                  ) : (
                    <>
                      <div className="dbo-gpt-markdown-main">
                        {/* 禁用时加 disabled true */}
                        <Download
                          onClick={() => {
                            console.log('click');
                            setRendering(true);
                            download();
                          }}
                          state={rendering ? 'loading' : ''}
                        ></Download>
                        <div
                          className="markdown-body"
                          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(renderText) }}
                          ref={markdownRef}
                        ></div>
                      </div>

                      {headings &&
                        Array.isArray(headings) &&
                        headings.length > 0 && (
                          <ul
                            className="dbo-markdown-preview-nav"
                            style={{
                              top:
                                wholeGameInfo?.show_warn ||
                                  wholeGameInfo?.edition_unified_id ===
                                  'e11000000297'
                                  ? 350
                                  : 265,
                            }}
                          >
                            {headings.map((item) => (
                              <li
                                className={`dbo-markdown-preview-nav-depth-${item.level
                                  } ${navigator === item.slug ? 'active' : ''}`}
                                key={item.slug}
                                onClick={debounce(debounceTime, () => {
                                  handleNavigatorScroll(
                                    item.slug,
                                    contentRef,
                                    10,
                                  );
                                })}
                              >
                                <a>{item.text}</a>
                              </li>
                            ))}
                          </ul>
                        )}
                    </>
                  )}
                </Col>
              </Row>
            </CardSlot>
          ) : (
            <LoadingTip
              loadingText=""
              style={{
                marginLeft: '48%',
                position: 'relative',
                marginTop: '30%',
              }}
            />
          )}
        </CardLoading>
      </>
    </>
  );
}
